import { createTheme } from '@mui/material/styles';
import { lendingClubPalette as lendingPalette } from './palette';
export default createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 768,
            md: 1024,
            lg: 1280,
            xl: 1440,
        },
    },
    palette: lendingPalette,
    typography: {
        allVariants: {
            fontWeight: 400,
        },
        fontFamily: "'Mulish', sans-serif",
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightSemibold: 600,
        fontWeightBold: 700,
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
});
